document.addEventListener('DOMContentLoaded', () => {

  // ===== FAQ ACCORDION =====
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const questionDiv = item.querySelector('.faq-question');
    if (questionDiv) {
      questionDiv.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        faqItems.forEach(other => other.classList.remove('active'));
        if (!isActive) item.classList.add('active');
      });
    }
  });

  // ===== PRODUCT GALLERY =====
  const thumbnails = document.querySelectorAll('.thumbnail-wrapper');
  const mainImage = document.querySelector('.main-image-wrapper img');
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-image-src');
      if (newSrc && mainImage) {
        mainImage.src = newSrc;
        if (mainImage.srcset) mainImage.removeAttribute('srcset');
      }
    });
  });

  // ===== QUANTITY SELECTORS (Product Page) =====
  window.changeQty = function(amount) {
    const display = document.getElementById('qtyDisplay');
    const input = document.getElementById('qtyInput');
    if (display) {
      let qty = parseInt(display.textContent) || 1;
      qty = Math.max(1, qty + amount);
      display.textContent = qty;
      if (input) input.value = qty;
    }
  };

  // ===== CART DRAWER =====
  // Build the drawer HTML and inject into <body> once
  function buildDrawer() {
    if (document.getElementById('cart-drawer')) return;
    const drawer = document.createElement('div');
    drawer.id = 'cart-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.innerHTML = `
      <div id="cart-drawer-overlay"></div>
      <div id="cart-drawer-panel" role="dialog" aria-modal="true" aria-label="Your cart">
        <div id="cart-drawer-header">
          <span id="cart-drawer-title">Your cart</span>
          <button id="cart-drawer-close" aria-label="Close cart">&#x2715;</button>
        </div>
        <div id="cart-drawer-body"></div>
        <div id="cart-drawer-footer"></div>
      </div>
    `;
    document.body.appendChild(drawer);
    document.getElementById('cart-drawer-close').addEventListener('click', closeDrawer);
    document.getElementById('cart-drawer-overlay').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  function openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    document.getElementById('cart-drawer-close').focus();
  }

  function closeDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
  }

  // Fetch cart JSON and render drawer contents
  function refreshDrawer() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderDrawer(cart));
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderDrawer(cart) {
    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    const titleEl = document.getElementById('cart-drawer-title');
    if (!body || !footer) return;

    const count = cart.item_count;
    titleEl.textContent = 'Your cart (' + count + ')';

    if (count === 0) {
      body.innerHTML = '<div class="drawer-empty"><div class="drawer-empty-icon">🛒</div><p>Your cart is empty</p><a href="/collections/all" class="drawer-shop-btn" onclick="closeDrawer()">Browse collection</a></div>';
      footer.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map((item, i) => `
      <div class="drawer-item" id="drawer-item-${i}">
        <div class="drawer-item-img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy" width="72" height="72">` : '<span class="drawer-img-placeholder">+</span>'}
        </div>
        <div class="drawer-item-info">
          <div class="drawer-item-title"><a href="${item.url}">${item.product_title}</a></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
          <div class="drawer-item-price">${moneyFormat(item.final_line_price)}</div>
          <div class="drawer-item-qty">
            <button type="button" class="drawer-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
            <span class="drawer-qty-num">${item.quantity}</span>
            <button type="button" class="drawer-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
            <button type="button" class="drawer-remove-btn" data-key="${item.key}" aria-label="Remove item">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    footer.innerHTML = `
      <div class="drawer-subtotal">
        <span>Subtotal</span>
        <span class="drawer-subtotal-price">${moneyFormat(cart.total_price)}</span>
      </div>
      <p class="drawer-tax-note">Taxes and shipping calculated at checkout</p>
      <a href="/checkout" class="drawer-checkout-btn">Proceed to Checkout →</a>
      <a href="/cart" class="drawer-view-cart">View full cart</a>
    `;

    // Wire up qty buttons
    body.querySelectorAll('.drawer-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const delta = parseInt(btn.dataset.delta);
        const qtyEl = btn.parentElement.querySelector('.drawer-qty-num');
        const currentQty = parseInt(qtyEl.textContent) || 1;
        const newQty = Math.max(0, currentQty + delta);
        updateCartItem(key, newQty);
      });
    });

    body.querySelectorAll('.drawer-remove-btn').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  // Update a single cart line via Cart API — no page reload
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(cart => {
      renderDrawer(cart);
      updateHeaderCount(cart.item_count);
    })
    .catch(err => console.error('Cart update failed:', err));
  }

  // Update the cart count badge in the header
  function updateHeaderCount(count) {
    const badge = document.querySelector('.cart-count');
    const btn = document.querySelector('.header-cart-btn');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else if (btn) {
        const span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = count;
        btn.appendChild(span);
      }
    } else {
      if (badge) badge.remove();
    }
  }

  // Make the header cart icon open the drawer instead of navigating
  buildDrawer();
  const headerCartBtn = document.querySelector('.header-cart-btn');
  if (headerCartBtn) {
    headerCartBtn.addEventListener('click', e => {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    });
  }

  // ===== AJAX ADD-TO-CART =====
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      const addBtn = productForm.querySelector('[name="add"]');
      const originalText = addBtn ? addBtn.textContent : '';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      const formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          // Error from Shopify (e.g. sold out)
          alert(data.description || 'Could not add to cart.');
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
          return;
        }
        if (addBtn) {
          addBtn.textContent = '✓ Added!';
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          }, 1800);
        }
        refreshDrawer().then(openDrawer);
        return fetch('/cart.js').then(r => r.json()).then(cart => updateHeaderCount(cart.item_count));
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
      });
    });
  }

  // ===== CART PAGE: AJAX quantity update (no full reload) =====
  window.changeCartQty = function(line, amount) {
    const qtySpan = document.getElementById('qty-' + line);
    const qtyInput = document.getElementById('Quantity-' + line);
    if (!qtySpan || !qtyInput) return;

    let qty = parseInt(qtySpan.textContent) || 1;
    qty = Math.max(0, qty + amount);
    qtySpan.textContent = qty;
    qtyInput.value = qty;

    // Disable buttons during update
    const cartItem = qtySpan.closest('.cart-item');
    if (cartItem) cartItem.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      if (cartItem) cartItem.style.opacity = '1';
      // If qty dropped to 0, remove the row from the DOM
      if (qty === 0 && cartItem) {
        cartItem.remove();
      }
      // Update the subtotal display on cart page
      const subtotalEl = document.querySelector('.cart-summary .amount');
      if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
      // Update line price
      const linePriceEl = cartItem ? cartItem.querySelector('.item-price') : null;
      if (linePriceEl) {
        const updatedItem = cart.items.find((_, i) => i + 1 === line);
        if (updatedItem) linePriceEl.textContent = moneyFormat(updatedItem.final_line_price);
      }
      updateHeaderCount(cart.item_count);
      // If cart is now empty, reload so empty-state renders
      if (cart.item_count === 0) location.reload();
    })
    .catch(err => {
      console.error('Cart update failed:', err);
      if (cartItem) cartItem.style.opacity = '1';
    });
  };

  // ===== VARIANT SELECTOR =====
  const variantForm = document.querySelector('.product-form');
  if (variantForm) {
    variantForm.addEventListener('change', (e) => {
      if (e.target && e.target.hasAttribute('data-variant-option')) {
        updateVariant();
      }
    });
    // Run once on load so price/state matches the pre-selected variant
    if (variantForm.querySelectorAll('[data-variant-option]').length > 0) {
      updateVariant();
    }
  }

  function updateVariant() {
    const form = document.querySelector('.product-form');
    if (!form) return;
    const selectedOptions = {};
    form.querySelectorAll('[data-variant-option]:checked').forEach(input => {
      selectedOptions[input.dataset.optionIndex] = input.value;
    });
    const variantData = window.__variantData__;
    if (!variantData || !variantData.length) return;

    // Match variants using only the option positions that are actually visible
    // (e.g. Size), ignoring hidden options (e.g. Color) which aren't shown as radios.
    const visiblePositions = Object.keys(selectedOptions).map(Number).sort((a, b) => a - b);
    const matchedVariant = variantData.find(v => {
      const vOptions = v.optionKey.split('|');
      return visiblePositions.every(pos => vOptions[pos - 1] === selectedOptions[pos]);
    });

    if (matchedVariant) {
      const variantInput = form.querySelector('[name="id"]');
      if (variantInput) variantInput.value = matchedVariant.id;

      const priceEl = document.querySelector('.price-current');
      if (priceEl && matchedVariant.priceFormatted) {
        priceEl.textContent = matchedVariant.priceFormatted;
      }

      const addBtn = document.querySelector('.btn-add-to-cart');
      if (addBtn) {
        if (matchedVariant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.labelAdd || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelSoldOut || 'Sold out';
        }
      }
    }
  }

  // ===== ADD-TO-CART BUTTON LABEL FALLBACK =====
  const addBtn = document.querySelector('.btn-add-to-cart');
  if (addBtn) {
    addBtn.dataset.labelAdd = addBtn.textContent.trim();
    addBtn.dataset.labelSoldOut = addBtn.disabled ? addBtn.textContent.trim() : 'Sold out';
  }

});